export default function useScriptLoader() {
	const scriptIsLoaded = ref(false)

	const checkIfScriptExists = (url: string) => {
		const scripts = document.getElementsByTagName('script')
		return Array.from(scripts).some((script: HTMLScriptElement) => script.src.includes(url))
	}

	const loadScript = (url: string) => {
		const exists = checkIfScriptExists(url)
		if (exists) {
			scriptIsLoaded.value = true
		} else {
			const s = document.createElement('script')
			s.setAttribute('src', url)
			s.defer = true
			s.async = true
			document.head.appendChild(s)
			s.onload = () => {
				scriptIsLoaded.value = true
			}
		}
	}

	return {
		scriptIsLoaded,
		loadScript
	}
}
